import React from 'react'

import { Grid } from '@mui/material'

import { UserCard } from './UserCard'

import { User } from '../../interfaces/User/UserWMS'

import { Loading } from '../UI'
import { PaginationTable } from '../UI/Table/TablePagination'

interface ListUserProps {
  users: User[]
  loading: boolean
  handleEditUser: (user: User) => void
  pagination: { page: number; pageSize: number; totalItem: number }
  setFirstEffect: React.Dispatch<React.SetStateAction<boolean>>
  firstEffect: boolean
  handleGetUser: () => void
  handleChangePage: (_event: unknown, newPage: number) => void
  handleChangeRowsPerPage: (event: React.ChangeEvent<HTMLInputElement>) => void
}

export const ListUser: React.FC<ListUserProps> = ({
  users,
  handleEditUser,
  loading,
  pagination,
  setFirstEffect,
  firstEffect,
  handleGetUser,
  handleChangePage,
  handleChangeRowsPerPage
}) => {
  React.useEffect(() => {
    if (!firstEffect) {
      handleGetUser()
    } else {
      setFirstEffect(false)
    }
  }, [pagination.page, pagination.pageSize])

  return loading ? (
    <Loading />
  ) : (
    <React.Fragment>
      <Grid container spacing={2} direction='row'>
        {users.map((user) => (
          <Grid item xs={12} sm={6} lg={4} xl={3}>
            <UserCard user={user} handleEditUser={() => handleEditUser(user)} />
          </Grid>
        ))}
      </Grid>
      {users.length > 0 && (
        <Grid
          container
          spacing={2}
          direction='row'
          style={{ justifyContent: 'end' }}
        >
          <PaginationTable
            pagination={pagination}
            handleChangePage={handleChangePage}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
          />
        </Grid>
      )}
    </React.Fragment>
  )
}
